import React, { useState } from "react";
import Filtro from './Filtro';
import Table from './Table';
import ReportAcordeon from '../../../Components/ReportAcordeon'
import { reportUserNoUpload } from "../../../../../services/NexiDigitalAPI";


const UploadsNaoRealizados = ({ index, expanded }) => {
    const name = "Uploads não realizados pelos usuários"
    const description = "";

    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState();

    const actionFilter = async (values) => {
        setLoading(true);
        const data = await reportUserNoUpload(values);
        setDados(data);
        setLoading(false);
    }


    const filter = (
        <Filtro 
            actionFilter={actionFilter} 
            loading={loading} 
        />
    );

    const result = (
        <Table 
            dados={dados} 
            loading={loading}
        />
    );
    
    return (
        <ReportAcordeon
            name={name}
            description={description}
            filter={filter}
            result={result}
            index={ index }
            expanded={expanded}
        />
        
    )
}

export default UploadsNaoRealizados;